<template>
  <div id="specialReportDetailPage"
       class="container-fluid has-action-bar has-footer">
    <ActionBar :title="actionBarTitle"></ActionBar>
    <div v-if="isContentLoaded" class="row container mx-auto p-0 mt-2">
      <div class="col-12 mx-auto p-1 my-2">
        <div class="bg-white round5px p-2">
          <v-img v-if="specialReportData.FileUrl !== null" :src="$replaceHttps(specialReportData.FileUrl)"
                 class="round5px" contain max-height="150"></v-img>
          <v-img v-else :src="getImgUrl('pishroLogo.png')" class="round5px"
                 contain max-height="150"></v-img>
          <div class="text-center mt-2 font16px mb-10">{{ specialReportData.Name }}</div>
          <div v-for="(item) in newReports" :key="item.formulaId" class="col-12 py-1 px-0">
            <router-link class="row no-gutters py-4 px-2 pl-0 card-right-line-blue bg-blue-gradient rounded-l-lg cursor-pointer d-flex"
                         @click="goToReportDetail(item)" :to="{path: 'ReportPage',query:{formulaId:item.formulaId,name:item.formulaName}}">
              <div class="col-2">
                <img :src="getImgUrl('file-report.png')" alt="پرونده" class="vertically-center img-fluid">
              </div>
              <div class="col-9">
                <div class="mt-1 white--text"> {{ item.formulaName}}</div>
              </div>
              <div class="col-1 text-center pl-3">
                <i class="fas fa-chevron-left vertically-center white--text px-1 "></i>
              </div>
            </router-link>
          </div>
          <div v-for="(item,index) in specialReportData.TypeReports" :key="index" class="col-12 py-1 px-0">
            <div class="row no-gutters py-4 px-2 pl-0 card-right-line-blue bg-blue-gradient rounded-l-lg cursor-pointer"
                 @click="goToReportDetail(item)">
              <div class="col-2">
                <img :src="getImgUrl('file-report.png')" alt="پرونده" class="vertically-center img-fluid">
              </div>
              <div class="col-9">
                <div class="mt-1 white--text"> {{ reportType[item] }}</div>
              </div>
              <div class="col-1 text-center pl-3">
                <i class="fas fa-chevron-left vertically-center white--text px-1 "></i>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <v-dialog
        v-model="showLoaderDialog"
        hide-overlay
        persistent
        width="500">
      <v-card class="text-center py-5">
        <v-progress-circular
            color="primary"
            indeterminate
        ></v-progress-circular>
      </v-card>
    </v-dialog>
    <FooterMenu/>
  </div>
</template>

<script>
let _this = null
import ActionBar from "../components/ActionBar";
import FooterMenu from "../components/FooterMenu";

export default {
  name: "SpecialReportDetail",
  components: {FooterMenu, ActionBar},
  data: () => ({
    item: null,
    isContentLoaded: false,
    showLoaderDialog: false,
    reportType: ['', 'سواد', ' یادگیری هر درس', 'جدول زمان نمره', 'مهارت عمومی', ' عملکرد متناسب با تخصص فردی', 'میزان استفاده از پتانسیل فردی', 'زمانی عملکرد های فردی', 'هوش هشتگانه', 'خواب', 'بی ام ای', 'سلامت جسمی', 'یکپارچگی عملکرد'],
    specialReportData: null,
    actionBarTitle: '',
    newReports: [],

  }),
  metaInfo() {
    return {
      title: 'مسیربرتر- ' + this.$route.query.Name
    }
  },
  mounted() {
    _this = this
    this.getData()
    this.actionBarTitle = this.$route.query.Name

  },
  methods: {
    getData() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", _this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "ReportCategoryManagement/SpecialReportsCategory?ReportCategoryID=" + this.$route.query.ReportCategoryID, requestOptions)
          .then(response => response.text())
          .then(result => {

            let json = JSON.parse(result)




            _this.specialReportData = json
            let formulaIds = json.FormulaIds
            let formulaNames = json.FormulaNames.split(',')
            let newReports = []
            for (let i = 0; i < formulaIds.length; i++) {
              newReports.push({formulaName: formulaNames[i], formulaId: formulaIds[i]})
            }
            this.newReports = newReports
            _this.isContentLoaded = true
            this.showLoaderDialog = false
          })
          .catch(error => console.log('error', error));
    },

    getImgUrl(pic) {
      return require('../assets/img/' + pic)
    },
    goToReportDetail(type) {
      switch (type) {
        case 1:
          this.$router.push({path: 'LiteracyChart'})
          return
        case 2:
          this.$router.push({path: 'LearnEachLesson'})
          return
        case 3:
          this.$router.push({path: 'ScoreScheduleEachLesson'})
          return
        case 4:
          this.$router.push({path: 'GeneralSkill'})
          return
        case 5:
          this.$router.push({path: 'PerformanceIndividualExpertise'})
          return
        case 6:
          this.$router.push({path: 'ExtentIndividualPotentialUse'})
          return
        case 7:
          this.$router.push({path: 'WhenIndividualAction'})
          return
        case 8:
          this.$router.push({path: 'SevenIntelligences'})
          return
        case 9:
          this.$router.push({path: 'SleepChartReport'})
          return
        case 10:
          this.$router.push({path: 'BMIChart'})
          return
        case 11:
          this.$router.push({path: 'PhysicalHealth'})
          return
        case 12:
          this.$router.push({path: 'FunctionalIntegrity'})
          return
      }
    }
  }
}
</script>
